module.exports = {
    GOOGLE_KEY:"AIzaSyA08YKZGPl0ii3K-t4_guTbdtjscGgdPns" 

}